import React from "react";
import { _t } from "app/i18n/i18n";
import { Alert } from "react-bootstrap";
// import { FormattedMessage } from "react-intl";
// import logToServer from "app/logToServer";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  componentDidCatch(error, info) {
    // logToServer("high", "Error Boundary", JSON.stringify(error));
    this.setState({ hasError: true });
  }

  render() {
    if (this.state.hasError) {
      return (
        <Alert variant="warning system-error m-2">
          {/* <FormattedMessage id="label.error.exception" /> */}
          <span className="text-center">
            {_t("Sorry this data is not currently available, please try again later.")}
          </span>
        </Alert>
      );
    }
    if (this.props.className) {
      return <section {...this.props}>{this.props.children}</section>;
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
